<div class="component-box" *ngIf="isSearchVisible">
  <form (ngSubmit)="onSearch()" class="search-form">
    <mat-tab-group animationDuration="0ms">
      <mat-tab>
        <ng-template mat-tab-label>
          Personal Characteristics<span class="filter-count" *ngIf="personalCharacteristicsCount > 0">({{ personalCharacteristicsCount }})</span>
        </ng-template>
        <div class="search-fields tab-content">
          <mat-form-field appearance="fill" *ngIf="fieldsConfig.showCode">
            <mat-label>Internal ID</mat-label>
            <input matInput [(ngModel)]="searchForm.code" name="code" placeholder="Search by internal ID">
          </mat-form-field>
          <mat-form-field appearance="fill" *ngIf="fieldsConfig.showFullName">
            <mat-label>Full Name</mat-label>
            <input matInput [(ngModel)]="searchForm.fullName" name="fullName" placeholder="Search by director name" appTextNormalize>
          </mat-form-field>
          <mat-form-field appearance="fill" *ngIf="fieldsConfig.showAgeFrom">
            <mat-label>Age From</mat-label>
            <input matInput type="number" [(ngModel)]="searchForm.ageFrom" name="ageFrom" placeholder="Age From">
          </mat-form-field>
          <mat-form-field appearance="fill" *ngIf="fieldsConfig.showAgeTo">
            <mat-label>Age To</mat-label>
            <input matInput type="number" [(ngModel)]="searchForm.ageTo" name="ageTo" placeholder="Age To">
          </mat-form-field>
          <mat-form-field appearance="fill" class="form-field" *ngIf="fieldsConfig.showGender">
            <mat-label>Gender</mat-label>
            <mat-select [(ngModel)]="searchForm.gender" name="gender" placeholder="Gender">
              <mat-option [value]="1">Male</mat-option>
              <mat-option [value]="2">Female</mat-option>
              <mat-option [value]="0">Unknown</mat-option>
            </mat-select>
            <button *ngIf="searchForm.gender !== undefined && searchForm.gender !== null" mat-icon-button matSuffix (click)="searchForm.gender = undefined; $event.stopPropagation()" tabindex="-1">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
          <mat-form-field appearance="fill" class="form-field" *ngIf="fieldsConfig.showNationality">
            <mat-label>Nationality</mat-label>
            <mat-select [(ngModel)]="searchForm.nationalityId" name="nationality" placeholder="Nationality">
              <mat-option *ngFor="let nationality of nationalities$ | async" [value]="nationality.id">
                {{ nationality.name }}
              </mat-option>
            </mat-select>
            <button *ngIf="searchForm.nationalityId" mat-icon-button matSuffix (click)="searchForm.nationalityId = undefined; $event.stopPropagation()" tabindex="-1">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
          <mat-form-field appearance="fill" class="form-field" *ngIf="fieldsConfig.showProfession">
            <mat-label>Profession</mat-label>
            <mat-select [(ngModel)]="searchForm.professionId" name="professionId" placeholder="Profession">
              <mat-option *ngFor="let profession of professions$ | async" [value]="profession.id">
                {{ profession.name }}
              </mat-option>
            </mat-select>
            <button *ngIf="searchForm.professionId" mat-icon-button matSuffix (click)="searchForm.professionId = undefined; $event.stopPropagation()" tabindex="-1">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </div>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          General<span class="filter-count" *ngIf="generalCount > 0">({{ generalCount }})</span>
        </ng-template>
        <div class="search-fields tab-content">
          <mat-form-field appearance="fill" class="form-field" *ngIf="fieldsConfig.showRegion">
            <mat-label>Region</mat-label>
            <mat-select [(ngModel)]="searchForm.region" name="region" placeholder="Region" (selectionChange)="onRegionChange()">
              <mat-option *ngFor="let region of regions" [value]="region.value">
                {{ region.label }}
              </mat-option>
            </mat-select>
            <button *ngIf="searchForm.region" mat-icon-button matSuffix (click)="searchForm.region = undefined; onRegionChange(); $event.stopPropagation()" tabindex="-1">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
          <mat-form-field appearance="fill" class="form-field" *ngIf="fieldsConfig.showCountry">
            <mat-label>Country</mat-label>
            <mat-select [(ngModel)]="searchForm.countryId" name="countryId" placeholder="Country">
              <mat-option *ngFor="let country of countries$ | async" [value]="country.id">
                {{ country.name }}
              </mat-option>
            </mat-select>
            <button *ngIf="searchForm.countryId" mat-icon-button matSuffix (click)="searchForm.countryId = undefined; $event.stopPropagation()" tabindex="-1">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
          <mat-form-field appearance="fill" class="form-field" *ngIf="fieldsConfig.showYear">
            <mat-label>Year</mat-label>
            <mat-select [(ngModel)]="searchForm.year" name="year" placeholder="Year">
              <mat-option *ngFor="let year of years" [value]="year">
                {{ year }}
              </mat-option>
            </mat-select>
            <button *ngIf="searchForm.year" mat-icon-button matSuffix (click)="searchForm.year = undefined; $event.stopPropagation()" tabindex="-1">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </div>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          Work Experience<span class="filter-count" *ngIf="workExperienceCount > 0">({{ workExperienceCount }})</span>
        </ng-template>
        <div class="search-fields tab-content">
          <mat-form-field appearance="fill" class="form-field" *ngIf="fieldsConfig.showMembershipType">
            <mat-label>Type</mat-label>
            <mat-select [(ngModel)]="searchForm.membershipType" name="membershipType" placeholder="Type">
              <mat-option *ngFor="let option of membershipTypeOptions" [value]="option.value">
                {{ option.label }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="fill" *ngIf="fieldsConfig.showCompany">
            <mat-label>Company</mat-label>
            <input matInput [(ngModel)]="searchForm.company" name="company" placeholder="Search by company name">
          </mat-form-field>
          <mat-form-field appearance="fill" class="form-field" *ngIf="fieldsConfig.showBoardMemberOccupation">
            <mat-label>Occupation</mat-label>
            <mat-select [(ngModel)]="searchForm.boardMemberOccupationId" name="boardMemberOccupationId" placeholder="Occupation">
              <mat-option *ngFor="let occupation of boardMemberOccupations$ | async" [value]="occupation.id">
                {{ occupation.name }}
              </mat-option>
            </mat-select>
            <button *ngIf="searchForm.boardMemberOccupationId" mat-icon-button matSuffix (click)="searchForm.boardMemberOccupationId = undefined; $event.stopPropagation()" tabindex="-1">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
          <mat-form-field appearance="fill" class="form-field" *ngIf="fieldsConfig.showClassification">
            <mat-label>Classification</mat-label>
            <mat-select [(ngModel)]="searchForm.classification" name="classification" placeholder="Classification">
              <mat-option *ngFor="let option of classificationOptions" [value]="option.value">
                {{ option.label }}
              </mat-option>
            </mat-select>
            <button *ngIf="searchForm.classification" mat-icon-button matSuffix (click)="searchForm.classification = undefined; $event.stopPropagation()" tabindex="-1">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
          <div *ngIf="fieldsConfig.showIndustry" class="industry-select-wrapper">
            <app-tree-select
              [data]="(industries$ | async) ?? []"
              label="Industry"
              placeholder="Select industry"
              (selectionChange)="onIndustrySelectionChange($event)">
            </app-tree-select>
          </div>
          <mat-form-field appearance="fill" class="form-field" *ngIf="fieldsConfig.showTenure">
            <mat-label>Tenure Min</mat-label>
            <input matInput type="number" min="0" [(ngModel)]="searchForm.tenureMin" name="tenureMin" placeholder="Min years">
          </mat-form-field>
          <mat-form-field appearance="fill" class="form-field" *ngIf="fieldsConfig.showTenure">
            <mat-label>Tenure Max</mat-label>
            <input matInput type="number" min="0" [(ngModel)]="searchForm.tenureMax" name="tenureMax" placeholder="Max years">
          </mat-form-field>
        </div>
      </mat-tab>
      <mat-tab *ngIf="fieldsConfig.showAdminTab !== false">
        <ng-template mat-tab-label>
          Admin<span class="filter-count" *ngIf="adminCount > 0">({{ adminCount }})</span>
        </ng-template>
        <div class="search-fields tab-content">
          <mat-form-field appearance="fill" class="form-field" *ngIf="fieldsConfig.showCreatedBy">
            <mat-label>User</mat-label>
            <mat-select [(ngModel)]="searchForm.createdBy" name="createdBy" placeholder="User">
              <mat-option *ngFor="let user of users$ | async" [value]="user.email">
                {{ user.fullName }}
              </mat-option>
            </mat-select>
            <button *ngIf="searchForm.createdBy" mat-icon-button matSuffix (click)="searchForm.createdBy = undefined; $event.stopPropagation()" tabindex="-1">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
          <mat-form-field appearance="fill" class="form-field" *ngIf="fieldsConfig.showDateFrom">
            <mat-label>Date From</mat-label>
            <input matInput [matDatepicker]="dateFromPicker" [(ngModel)]="searchForm.dateFrom" name="dateFrom">
            <mat-datepicker-toggle matIconSuffix [for]="dateFromPicker"></mat-datepicker-toggle>
            <mat-datepicker #dateFromPicker></mat-datepicker>
          </mat-form-field>
          <mat-form-field appearance="fill" class="form-field" *ngIf="fieldsConfig.showDateTo">
            <mat-label>Date To</mat-label>
            <input matInput [matDatepicker]="dateToPicker" [(ngModel)]="searchForm.dateTo" name="dateTo">
            <mat-datepicker-toggle matIconSuffix [for]="dateToPicker"></mat-datepicker-toggle>
            <mat-datepicker #dateToPicker></mat-datepicker>
          </mat-form-field>
          <mat-checkbox *ngIf="fieldsConfig.showDeceased" [(ngModel)]="searchForm.isDeceased" name="isDeceased">Passed Away</mat-checkbox>
          <mat-form-field appearance="fill" class="form-field" *ngIf="fieldsConfig.showIsNotCompleted">
            <mat-label>Profile Status</mat-label>
            <mat-select [(ngModel)]="searchForm.profileStatus" name="profileStatus" placeholder="Profile Status">
              <mat-option value="all">All</mat-option>
              <mat-option value="completed">Is Completed</mat-option>
              <mat-option value="notCompleted">Is Not Completed</mat-option>
            </mat-select>
            <button *ngIf="searchForm.profileStatus && searchForm.profileStatus !== 'all'" mat-icon-button matSuffix (click)="searchForm.profileStatus = 'all'; $event.stopPropagation()" tabindex="-1">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </div>
      </mat-tab>
    </mat-tab-group>
    <div class="search-actions">
      <mat-checkbox [(ngModel)]="showBoardMemberships" name="showBoardMemberships" color="primary" (change)="onShowBoardMembershipsChange()">Show Board Memberships</mat-checkbox>
      <div class="search-actions-spacer"></div>
      <button mat-flat-button color="primary" type="submit">
        <mat-icon>search</mat-icon>
        Search
      </button>
      <button mat-flat-button type="button" class="nrg-error-flat-button"  (click)="clearSearch()">
        <mat-icon>clear</mat-icon>
        Clear
      </button>
    </div>
  </form>
</div>
